import type { PieceType, Uci } from '@chess/api-model';
import type { MoveInput } from './interface.ts';

/**
 * A UCI move (`e2e4`, `e7e8q`) as the input `chess.play` takes: the first
 * two squares, and the fifth character, when there is one, as the piece a
 * pawn becomes.
 */
export function uciToInput(uci: Uci): MoveInput {
  const promotion = uci.length > 4 ? (uci[4].toLowerCase() as PieceType) : undefined;
  return promotion ? { from: uci.slice(0, 2), to: uci.slice(2, 4), promotion } : { from: uci.slice(0, 2), to: uci.slice(2, 4) };
}

/** A move input as UCI: the two squares, then the promotion piece if any. */
export function inputToUci(input: MoveInput): Uci {
  return input.from + input.to + (input.promotion ?? '');
}
